module.exports = __webpack_public_path__ + "media/images/google-play-194cc0b884101432aa18d9a0346a0324.png";